import { FC } from 'react';

type Props = {
	className?: string;
};

const SquareLockIcon: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='none'
			stroke='#2B2B2B'
			className={className}>
			<path
				d='M10 13.6V12'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
			/>
			<path
				d='M3.81435 15.4759C3.99425 16.8122 5.10102 17.859 6.44785 17.9209C7.58115 17.973 8.7324 18.0002 10.0002 18.0002C11.2679 18.0002 12.4192 17.973 13.5524 17.9209C14.8993 17.859 16.0061 16.8122 16.186 15.4759C16.3034 14.6039 16.4002 13.7102 16.4002 12.8001C16.4002 11.8901 16.3034 10.9964 16.186 10.1244C16.0061 8.78811 14.8993 7.74129 13.5524 7.67937C12.4192 7.62727 11.2679 7.6001 10.0002 7.6001C8.7324 7.6001 7.58115 7.62727 6.44785 7.67937C5.10102 7.74129 3.99425 8.78811 3.81435 10.1244C3.69694 10.9964 3.6001 11.8901 3.6001 12.8001C3.6001 13.7102 3.69694 14.6039 3.81435 15.4759Z'
				stroke='inherit'
				strokeWidth='1.25'
			/>
			<path
				d='M6.3999 7.60006V5.60004C6.3999 3.61179 8.01169 2 9.99994 2C11.9882 2 13.6 3.61179 13.6 5.60004V7.60006'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default SquareLockIcon;
